module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-heart-eyes-6cd9b79b.svg";